<template>
<div>
  <div class="col-12 loader-block" v-if="loader">
    <loader-component></loader-component>
  </div>

  <div class="col-12 row input-setting-block" v-if="!loader">
    <div class="offset-1 col-1 elips"></div>
    <div class="col-2 item-name">
      Таймер перехода в АВТО режим
    </div>
    <div class="col-2 to-auto-mode-checkbox-block">
      <input  id="timer-status"
                v-model="timer_status" @change="changeToAutomodeStatus" type="checkbox" autocomplete="off">
      <label for="timer-status">.</label>
    </div>
    <div class="row col-5" v-if="timer_status">
      <div class="col-6">
        <input v-model="time">
  </div>
        <div class="col-4 time-text">
          <p>Время в часах</p>
        </div>
      </div>
      <div class="offset-4 col-7 text-info-after-input-block">
        <p>Таймер определяет через сколько часов РУЧНОЙ режим станет АВТО</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import loader from './loader.vue'

export default {
  created: function () {
    getTimer(this)
    this.setinreval_getTimer = setInterval(() => {
        getTimer(this)
    }, 20000);
  },
  components: {
    'loader-component': loader,
  },
  data() {
    return {
      timer_status: null,
      time: null,
      safe_timer_status: null,
      safe_time: null,
      loader: true,
      updaters: 0,
      setinreval_getTimer: null
    }
  },
  methods: {
      changeToAutomodeStatus: function () {
          changeTimer(this)
      }
  },
  props: ['id_faucet'],
  watch: {
    // timer_status: function (this_time_status, old_time_status) {
    //     console.log(this_time_status)
    //     console.log(old_time_status)
    //   if (old_time_status != null && this_time_status != old_time_status) {
    //     changeTimer(this)
    //   }
    // },
    time: function (this_times, old_time) {
        if (old_time != null && this_times != old_time && this_times != this.safe_time) {
            this.updaters += 1
            setTimeout(() => {
            if (this.time == this_times) {
                changeTimer(this)
                this.updaters = 0
            }
            this.updaters -= 1
            }, 1000)
        }
    }
  },
  destroyed() {
      clearInterval(this.setinreval_getTimer)
  },
}

function getTimer(vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_faucet', vue_obj.id_faucet)

  axios({
      method: 'POST',
      url: config.API_HOST + '/faucets/get_to_auto_mode_faucet',
      data: post_data
    })
    .then(function (response) {
      if (typeof response.data.time_to_auto_mode_status !=='undefined' && vue_obj.updaters == 0) {
        vue_obj.safe_timer_status = response.data.time_to_auto_mode_status
        vue_obj.timer_status = response.data.time_to_auto_mode_status
      }
      if (!!response.data.time_to_auto_mode && vue_obj.updaters == 0) {
          changeInputTime(vue_obj, response.data.time_to_auto_mode, true)
      }
      vue_obj.loader = false
    })
    .catch(function (error) {
      console.log(error)
    })
}

function changeTimer(vue_obj) {
    if ((vue_obj.timer_status != null && vue_obj.timer_status != vue_obj.safe_timer_status) || 
        (vue_obj.time != null && vue_obj.time != vue_obj.safe_time)) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_faucet', vue_obj.id_faucet)
        post_data.set('status', vue_obj.timer_status ? true : false)
        if (vue_obj.timer_status) {
            if (vue_obj.time < 1) vue_obj.time = 1
            post_data.set('hour_to_auto_mode', vue_obj.time)
        } else {
            post_data.set('hour_to_auto_mode', 0)
        }

        axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/change_time_to_auto_mode',
            data: post_data
        })
        .then(function (response) {
        console.log(response)
        if (!!response.data.time_to_auto_mode) {
            changeInputTime(vue_obj, response.data.time_to_auto_mode)
        }
        })
        .catch(function (error) {
        console.log(error)
        })
    }
}

function changeInputTime(vue_obj, unix_time_to_auto_mode, safe_status) {
  var hours_to_automode = Math.round((unix_time_to_auto_mode - parseInt(new Date().getTime() / 1000)) / 60 / 60)
  if (hours_to_automode > 0) {
    if (safe_status) {
        vue_obj.safe_time = hours_to_automode
    }
    vue_obj.time = hours_to_automode
  } else {
    if (safe_status) {
        vue_obj.safe_time = 1
    }
    vue_obj.time = 1
  }
}
</script>

<style scoped>
.loader-block {
  margin-top: 35px;
}

.to-auto-mode-checkbox-block {
    padding: 5px 0 0 70px;
}

.time-text {
    padding: 20px 0;
}

.warning-auto-close-checkbox-block {
    padding: 10px 0 0 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/manual-mode.vue